import {Box} from 'src/design/atoms/Box';
import React from 'react';
import type {ReportSimpleResponse} from 'src/api/ProactApiClient';
import {useGetReportListQuery} from 'src/redux/queries/report';
import {SelectBox} from 'src/design/atoms/SelectBox';
import type {ISelectOption} from 'src/types/Form';

export interface ReportListProps {
  selectedReportId?: string;
  onReportSelect: (report?: ReportSimpleResponse) => void;
}
export const ReportList: React.FC<ReportListProps> = ({
  selectedReportId,
  onReportSelect,
}) => {
  const {data} = useGetReportListQuery({start: 0, length: 1000});
  const reports = data?.data ?? [];
  const reportData: ISelectOption[] = reports.map(
    r => ({id: r.dashboardId, label: r.name} as ISelectOption)
  );

  const handleSelectionChange = (id: string) => {
    const report = reports.find(r => r.dashboardId === id);

    onReportSelect(report);
  };
  return (
    <Box w="300px" mb="xs">
      <SelectBox
        label={selectedReportId ? '' : 'Available Reports'}
        options={reportData}
        value={selectedReportId}
        onSelectChangeCallback={handleSelectionChange}
      />
    </Box>
  );
};
